<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.063.063h19.874v19.875H.063V.063z" />
    <path
      d="M15.52 8.344V4.48c0-.608-.497-1.105-1.103-1.105H1.167C.56 3.375.063 3.872.063 4.48v11.04c0 .608.496 1.105 1.104 1.105h13.25c.606 0 1.103-.497 1.103-1.105v-3.864l4.418 4.417V3.927L15.52 8.344z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
